import React from "react";
import { LabeledRow } from "@components/LabeledRow";
import { AddressKind, FetchCustomerData } from "@customTypes/responses/customer";
import { addressTypeDictionary } from "../tabs/constants";

type AddressListProps = {
  addresses: FetchCustomerData["address"];
};

const AddressList: React.FC<AddressListProps> = ({ addresses }) => {
  const typeSet = new Set<AddressKind>();
  addresses.forEach((address) => typeSet.add(address.typeEnum));
  const addressListByType: FetchCustomerData["address"][] = [];

  typeSet.forEach((type) => {
    addressListByType.push(addresses.filter((address) => address.typeEnum == type));
  });

  return (
    <>
      {addressListByType.map((addresses) => {
        const type = addresses[0].typeEnum;
        const valueList = addresses.map((address) => address.value);

        return <LabeledRow key={type} label={addressTypeDictionary[type]} values={valueList} />;
      })}
    </>
  );
};

export default AddressList;
